// imports section Start
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CardMedia,
} from "@mui/material";
import marriott from "../../../assets/images/marriott-logo.png";
import no_image from "../../../assets/images/no_image.png";
import { BASEURL } from "../../../config/Config";
// imports section End

function CashReceiptHeader({ billOptions, mappedOptions, orderPayload }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPANYLOGO } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const {
    Table1: orderDetails = [], // Rename Table1 to orderSummary
    Table2: itemCharges = [], // Rename Table2 to itemDetails
    Table3: cartItems = [], // Rename Table3 to totals
  } = orderPayload || {};

  // Replace this with your actual Base64 string
  const staticLogoBase64 = `data:image/png;base64,iVBORw0...`;

  const logoSrc = orderDetails?.[0]?.LOGOIMAGE
    ? `data:image/png;base64,${orderDetails[0].LOGOIMAGE}`
    : staticLogoBase64;

  const companyLogoUrl = COMPANYLOGO
    ? `${COMPANYLOGO.replace("~/", "")}`
    : null;

  // Handlers end

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {mappedOptions.has(1) && (
          // <Box
          //   component="img"
          //   src={logoSrc}
          //   alt={`{orderDetails?.[0]?.RESTNAME} Logo`}
          //   sx={{
          //     width: "40%",
          //     height: "auto",
          //     objectFit: "cover",
          //   }}
          // />

          <CardMedia
            component="img"
            src={companyLogoUrl || no_image} // If marriott is static, else use details.COMPCODE based logic
            sx={{
              width: 84,
              height: 84,
              m: 1,
              // maxWidth: "40px",
              mt: 1,
              // mb: 2,
              borderRadius: 1,
              border: `3px solid ${theme.palette.background.paper}`,
              boxShadow: 2,
              transition: "transform 0.3s",
            }}
          />
        )}
        {mappedOptions.has(2) && (
          <Typography
            variant="title"
            align="center"
            sx={{ marginBottom: "4px", mt: 1 }}
          >
            {orderDetails?.[0]?.RESTNAME}
          </Typography>
        )}
        {mappedOptions.has(3) && (
          <Typography
            variant="body2"
            align="center"
            sx={{ marginBottom: "2px" }}
          >
            {orderDetails?.[0]?.ADDRESS1} {orderDetails?.[0]?.ADDRESS2}{" "}
            {orderDetails?.[0]?.ADDRESS3}
          </Typography>
        )}
        {mappedOptions.has(4) && (
          <Typography
            variant="body2"
            align="center"
            sx={{ marginBottom: "2px" }}
          >
            {orderDetails?.[0]?.LOCTEL}
          </Typography>
        )}
        {mappedOptions.has(5) && (
          <Typography variant="body2" align="center">
            {orderDetails?.[0]?.ENUSER}
          </Typography>
        )}
      </Box>
      <Divider sx={{ marginY: 1 }} />
    </>
  );
}

export default CashReceiptHeader;
